import React from 'react'
import CreationModalProgressContextProvider from '../context/CreationModalProgressContextProvider'
import { ProvidersModalPurpose, useProvidersModal } from '../context/ProvidersModalContext'
import ConnectProvidersModal from '../pages/ResourceCollection/Collections/Provider/ConnectProviders/ConnectProvidersModal'
import RemindProvidersModal from '../pages/ResourceCollection/Collections/Provider/ConnectProviders/RemindProvidersModal'
import ScheduleEnrichmentModal from '../pages/ResourceCollection/Collections/Provider/ScheduleEnrichment/ScheduleEnrichmentModal'
import ScheduleProviderScreeningModal from '../pages/ResourceCollection/Collections/Provider/ScheduleScreening/ScheduleProviderScreeningModal'
import { ConnectOnlyFlowProvidersModal } from '../pages/ResourceCollection/Collections/Providers'

const MODAL_COMPONENTS = {
  [ProvidersModalPurpose.InitialInvitation]: ConnectProvidersModal,
  [ProvidersModalPurpose.ExtraReminder]: RemindProvidersModal,
  [ProvidersModalPurpose.ConnectOnlyFlow]: ConnectOnlyFlowProvidersModal,
  [ProvidersModalPurpose.ScheduleScreening]: ScheduleProviderScreeningModal,
  [ProvidersModalPurpose.ScheduleEnrichment]: ScheduleEnrichmentModal,
  [ProvidersModalPurpose.Connect]: null,
} as const

const ProvidersModals = () => {
  const { isConnectDialogOpen, handleCloseConnectDialog, modalPurpose } = useProvidersModal()

  const ModalComponent = MODAL_COMPONENTS[modalPurpose]

  if (!ModalComponent) {
    return null
  }

  return (
    <CreationModalProgressContextProvider>
      <ModalComponent open={isConnectDialogOpen} onClose={handleCloseConnectDialog} />
    </CreationModalProgressContextProvider>
  )
}

export default ProvidersModals
